/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
import * as React from 'react';
import { useTheme } from '../utils/index.js';
import cx from 'classnames';
/**
 * Fieldset component to group several inputs, controls and labels within a form.
 * @example
 * <Fieldset legend='Settings'>
 *   <Input />
 *   <InputGroup>
 *     <ToggleSwitch />
 *     <ToggleSwitch />
 *   </InputGroup>
 * </Fieldset>
 */
export const Fieldset = (props) => {
    const { children, className, disabled, legend, ...rest } = props;
    useTheme();
    return (React.createElement("fieldset", { className: cx('iui-fieldset', className), disabled: disabled, ...rest },
        legend && React.createElement("legend", null, legend),
        disabled
            ? React.Children.map(children, (child) => React.isValidElement(child)
                ? React.cloneElement(child, { disabled: true })
                : child)
            : children));
};
export default Fieldset;
